'use strict';

// export this package's api
module.exports = require('./Upload');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.2.0@rc-upload/lib/index.js
 ** module id = 443
 ** module chunks = 0
 **/